import * as React from 'react';
import styled from 'styled-components';
import {mixinBtnSmall, mixinResetBtnCss, mixinBtnCancel, mixinWithBtnPropsFn, IBtnDefaultProps} from "./btn_mixin";
import {Link, LinkProps} from "react-router-dom";

interface IProps
    extends IBtnDefaultProps, LinkProps {
}

const BtnLinkCancelSmallDefault: React.FC<IProps> = (props) => {

    const { icon, widthSize, ...ButtonProps } = props;

    return (<Link {...ButtonProps} />)

};

const BtnLinkCancelSmall = styled(BtnLinkCancelSmallDefault)`
    ${mixinResetBtnCss}
    ${mixinBtnSmall}
    ${mixinBtnCancel}
    
    ${props => mixinWithBtnPropsFn(props)}
`;

export default BtnLinkCancelSmall;


// WEBPACK FOOTER //
// ./src/presentation/common/atom/btn/btn_link_cancel_small.tsx